import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 15, viewBox: "0 0 16 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.6667 1.5H1.33337L6.66671 7.80667V12.1667L9.33337 13.5V7.80667L14.6667 1.5Z", stroke: "#1F2D67", style: {
  stroke: "#1F2D67",
  stroke: "color(display-p3 0.1233 0.1774 0.4055)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
